<div class="sidebar" role="dialog">

	<app-sidebar-header [title]="'extrasSidebar.lisboaCard.title.lisboaTitle' | ibeadmin | async" >
		<div actions>
			<button class="button button--small" 
				*ngIf="INDRA_showHandleDone()"
				(click)="!isModificationDisallowed ? INDRA_handleDone() : INDRA_closeSidebar()"
				[attr.aria-label]="'extrasSidebar.lisboaCard.aria.confirmChanges' | ibeadmin | async">
				{{ 'extrasSidebar.lisboaCard.label.done' | ibeadmin | async }}
			</button>
		</div>
	</app-sidebar-header>

	<div class="block-stopover">
		<div class="grid">
			<div class="col-12 col-tp-12 col-p-12">
				<app-svg class="icon" svg="icons.svg#services--book_hotel" aria-hidden="true" [alt]="'extrasSidebar.lisboaCard.aria.confirmChanges' | ibeadmin | async"></app-svg>
				{{ 'extrasSidebar.lisboaCard.text.stopoverIn' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }}
			</div>
		</div>
	</div>


	<div class="sidebar__body sl--scrollable sidebar_body-wrapper" #sidebar__body>

		<div class="block-image" alt="">
			<img src="./assets/images/destinations/banner/LIS1.jpg" alt="" />
		</div>

		<div #sidebar__info class="sidebar__info bottom-gap">
			<ul class="vantages-listing">
				<li>{{ 'extrasSidebar.lisboaCard.text.freeEntry' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.lisboaCard.text.freeTranspo' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.lisboaCard.text.discountSeveral' | ibeadmin | async }}</li>
				<li>{{ 'extrasSidebar.lisboaCard.text.percentDiscount' | ibeadmin | async }}</li>
			</ul>

			<a class="link link--external" title="Open dialog forAll about {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} card" href="javascript:;"
			(click)="INDRA_goToURL()">
				{{ 'extrasSidebar.lisboaCard.text.allAbout' | ibeadmin | async }} {{ 'extrasSidebar.text.countryLisbon' | ibeadmin | async }} {{ 'extrasSidebar.lisboaCard.text.card' | ibeadmin | async }}
			</a>
		</div>

		<hr class="separator" aria-hidden="true">

		<div class="grid no-padding">

			<div class="col-6 col-p-12 form-label">
				{{ 'extrasSidebar.lisboaCard.text.allPassengers' | ibeadmin | async }}
			</div>

			<div class="col-6 col-p-12 align-right display--flex" *ngIf="form.get('voucher').value">

				<button class="button button-secondary button--icon-right full-width" role="alert" [attr.aria-label]="'extrasSidebar.lisboaCard.aria.voucherAdded' | ibeadmin | async">
					{{ 'extrasSidebar.lisboaCard.text.voucherAdded' | ibeadmin | async }}
					<app-svg svg="icons.svg#general--check" aria-hidden="true" [alt]="'extrasSidebar.lisboaCard.alt.checkedIcon' | ibeadmin | async"></app-svg>
				</button>
				<!-- <span class="text-button">
					Free
				</span> -->
				<app-svg *ngIf="!isModificationDisallowed && !extra[0]['readOnly']" 
					[title]="'extrasSidebar.lisboaCard.aria.removeVoucher' | ibeadmin | async" 
					[attr.aria-label]="'extrasSidebar.lisboaCard.aria.removeVoucher' | ibeadmin | async" 
					[ngClass]="['remove-extra']" 
					svg="icons.svg#general--close" 
					(click)="INDRA_removeVoucher()" 
					aria-hidden="true" 
					[alt]="'extrasSidebar.lisboaCard.alt.removeIcon' | ibeadmin | async" 
					tabindex="0">
				</app-svg>

			</div>

			<div class="col-6 col-p-12 align-right" *ngIf="!isModificationDisallowed && !form.get('voucher').value">
				<button class="button button-main-line full-width" (click)="INDRA_addVoucher()" [attr.aria-label]="'extrasSidebar.lisboaCard.aria.addDiscountVoucher' | ibeadmin | async">
					{{ 'extrasSidebar.lisboaCard.label.addDiscountVoucher' | ibeadmin | async }}
				</button>
			</div>

		</div>

		<hr class="separator" aria-hidden="true">

		<ng-container *ngIf="INDRA_showHandleDone()">
			<div class="sidebar__totals" *ngIf="!isModificationDisallowed && form.get('voucher').value">
				<div class="total">
					<label class="label">
						{{ 'extrasSidebar.lisboaCard.text.1item' | ibeadmin | async }}
					</label>
					<p class="value">{{ 'extrasSidebar.lisboaCard.text.price' | ibeadmin | async }}</p>

				</div>

				<p class="muted">
					<!-- {{ 'extrasSidebar.lisboaCard.text.discountVoucherFree' | ibeadmin | async }}<br> -->
					{{ 'extrasSidebar.lisboaCard.text.grayLine' | ibeadmin | async }}
				</p>

			</div>

			<button class="button full-width button--small" 
				(click)="!isModificationDisallowed ? INDRA_handleDone() : INDRA_closeSidebar()" 
				[attr.aria-label]="'extrasSidebar.lisboaCard.aria.confirmAddedVoucher' | ibeadmin | async">
				{{ 'extrasSidebar.lisboaCard.label.done' | ibeadmin | async }}
			</button>
		</ng-container>

		<ng-container *ngIf="hasError">
			<div class="container">
				<app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" 
					[title]="'extrasSidebar.lisboaCard.title.internalError' | ibeadmin | async">
					<div message>
						<span>
							{{ 'extrasSidebar.lisboaCard.text.internalOccurred' | ibeadmin | async }}
						</span>
					</div>
				</app-notification>
			</div>
		</ng-container>


		<div class="conditions">
			<h3 class="title-h3 conditions__title">{{ 'extrasSidebar.lisboaCard.title.conditions' | ibeadmin | async }}</h3>
			<div class="conditions__text">
				<div class="grid">
					<div class="col-12">
						<ul class="bullet-list">
							<li>{{ 'extrasSidebar.lisboaCard.text.toBenefitFromTheOffer' | ibeadmin | async }}
								<a
									class="link"
									target=”_blank”
									href="{{ 'externalURLs.visitLisboaCard' | ibeadmincfg }}"
									[attr.aria-label]="'extrasSidebar.lisboaCard.label.openLisboaCard' | ibeadmin | async"
								>
									{{ 'extrasSidebar.lisboaCard.text.openLisboaCard' | ibeadmin | async }}
								</a>
							</li>
							<li>{{ 'extrasSidebar.lisboaCard.text.tapPartner' | ibeadmin | async }}</li>
							<li>{{ 'extrasSidebar.lisboaCard.text.allPayments' | ibeadmin | async }}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

	</div>
</div>
